import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const digitalLiteracyExercises: TopicExercises = {
  mcqs: [
    {
      id: "dl1",
      difficulty: "easy",
      topic: "boolean",
      anchor: "and-operator",
      question: "Search me AND operator ka basic use kya hai?",
      options: ["Dono words ko sath dhoondna", "Har result hata dena", "Sirf images dhoondna", "Website block karna"],
      correctIndex: 0,
      explanation: "AND ka matlab hai dono terms result me hon.",
    },
    {
      id: "dl2",
      difficulty: "easy",
      topic: "digital-literacy",
      anchor: "what-is-digital-literacy",
      question: "Digital literacy ka simple matlab kya hai?",
      options: ["Computer banana", "Information ko online samajh kar sahi use karna", "Sirf typing karna", "Games install karna"],
      correctIndex: 1,
      explanation: "Digital literacy me search, evaluation aur safe use sab include hota hai.",
    },
    {
      id: "dl3",
      difficulty: "medium",
      topic: "evaluation",
      anchor: "reliable-source",
      question: "Reliable source pehchanne ka acha signal kya hai?",
      options: ["Unknown author", "Clear author aur trusted site", "Sirf colorful design", "Bohat ads hona"],
      correctIndex: 1,
      explanation: "Trusted source me author, date aur credibility clear hoti hai.",
    },
    {
      id: "dl4",
      difficulty: "medium",
      topic: "online-libraries",
      anchor: "academic-resources",
      question: "Peer-reviewed ya academic material aam tor par kahan milta hai?",
      options: ["Random chat group", "Digital libraries", "Gaming app", "Social media comments"],
      correctIndex: 1,
      explanation: "Academic resources structured databases aur digital libraries me milte hain.",
    },
    {
      id: "dl5",
      difficulty: "easy",
      topic: "intellectual-property",
      anchor: "copyright",
      question: "Creative work ko unauthorized copy se bachane ka concept kya hai?",
      options: ["Boolean", "Copyright", "Phishing", "Spam"],
      correctIndex: 1,
      explanation: "Copyright creative content ke rights protect karta hai.",
    },
    {
      id: "dl6",
      difficulty: "medium",
      topic: "search",
      anchor: "good-query",
      question: "Kaunsi query zyada specific search show kare gi?",
      options: ["computer", "history", "11th class digital literacy boolean operators", "study"],
      correctIndex: 2,
      explanation: "Specific keywords better aur focused results laate hain.",
    },
    {
      id: "dl7",
      difficulty: "hard",
      topic: "evaluation",
      anchor: "bias-check",
      question: "Bias check karte waqt kya dekhna chahiye?",
      options: ["Kya source sirf aik side dikha raha hai", "Kya font bada hai", "Kya page me animation hai", "Kya logo blue hai"],
      correctIndex: 0,
      explanation: "Bias ka matlab source ka one-sided ya unfair angle bhi ho sakta hai.",
    },
    {
      id: "dl8",
      difficulty: "easy",
      topic: "boolean",
      anchor: "not-operator",
      question: "NOT operator ka use kab hota hai?",
      options: ["Extra words add karne ke liye", "Kisi unwanted term ko exclude karne ke liye", "Result save karne ke liye", "Author dhoondne ke liye"],
      correctIndex: 1,
      explanation: "NOT unwanted result ko hata deta hai.",
    },
  ],
  short: [
    {
      id: "dl-short-1",
      question: "Reliable source ko kaise pehchana jata hai?",
      answer: "Author, date, trusted website aur balanced information dekh kar source evaluate kiya jata hai.",
    },
    {
      id: "dl-short-2",
      question: "Keyword usage search me kyun important hoti hai?",
      answer: "Specific keywords zyada relevant aur focused results laati hain.",
    },
    {
      id: "dl-short-3",
      question: "Plagiarism kya hota hai?",
      answer: "Kisi aur ka kaam bina credit ke apna bana kar use karna plagiarism hota hai.",
    },
  ],
  long: [
    {
      id: "dl-long-1",
      question: "Online research process explain karo.",
      solution: "Online research me pehle clear topic select kiya jata hai, phir specific keywords use karke search ki jati hai. Us ke baad sources ko evaluate kiya jata hai aur sirf reliable information ko note kiya jata hai.",
      steps: [
        "Research topic clear karo.",
        "Specific keywords ya boolean operators use karo.",
        "Source ki reliability check karo.",
        "Useful points ko proper reference ke sath note karo.",
      ],
    },
    {
      id: "dl-long-2",
      question: "Digital literacy ki importance explain karo.",
      solution: "Digital literacy students ko online information ko sahi samajhne, trusted sources choose karne aur safe tareeqe se use karne me help karti hai. Is se fake information aur misuse se bachna easy hota hai.",
      steps: [
        "Information ko blindly accept nahi karna chahiye.",
        "Reliable aur unreliable source me farq samajhna zaroori hai.",
        "Intellectual property aur safe online behavior ka respect karna chahiye.",
      ],
    },
  ],
};
